import { useSelector } from 'react-redux'

import type { FC, ReactNode } from 'react'

interface ContentColumnsProps {
  columns: [ReactNode, ReactNode | undefined]
  source: string
}

const ContentColumns: FC<ContentColumnsProps> = ({ columns, source }) => {
  const useTwoColumns = useSelector(
    ({ environment }: { environment: { stage: { width: number } } }) => environment.stage.width > 1080,
  )

  if (!columns || !columns.at) {
    // eslint-disable-next-line no-console
    console.error(`ContentColumns from ${source}: columns prop is required: ${typeof columns}`)
    return null
  }

  return (
    <div className="ContentColumns flex gap-2 mx-auto max-w-screen-1366 w-full">
      <div className={useTwoColumns && columns.at(1) ? 'w-full max-w-50/100' : 'w-full'}>{columns.at(0)}</div>
      {useTwoColumns && !!columns.at(1) && <div className="w-full max-w-50/100">{columns.at(1)}</div>}
    </div>
  )
}

export default ContentColumns
